import siThunkDependencies from "app/pages/sales-intelligence/store/thunk-dependencies";
import type { SalesIntelligenceThunkDeps } from "app/pages/sales-intelligence/types/state/effects";

export type ThunkDependencies = {
    si: SalesIntelligenceThunkDeps;
};

const thunkDependencies: ThunkDependencies = {
    si: siThunkDependencies,
};

export default thunkDependencies;
